import { useRef, useState, SyntheticEvent, DragEvent } from "react";
import { Trans } from "react-i18next";

interface UploadCSVType {
  handelFileUpload: (fileInfo: File[]) => void;
}

const UploadCSV = ({ handelFileUpload }: UploadCSVType) => {
  const fileInput = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  const onUploadClick = () => {
    fileInput?.current?.click();
  };

  const handleFileInputChange = (event: SyntheticEvent<EventTarget>) => {
    event.preventDefault();
    event.stopPropagation();
    const fileUploaded = (event.target as HTMLFormElement).files;
    handelFileUpload([...fileUploaded]);
  };

  const handleDragEnter = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setDragging(true);
  };

  const handleDragLeave = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setDragging(false);
  };

  const handleDrop = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    const dataFiles = event?.dataTransfer;
    const files: any = dataFiles ? [...dataFiles.files] : [];
    handelFileUpload(files);
  };

  const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setDragging(true);
  };

  return (
    <div
      onClick={onUploadClick}
      className={dragging ? "uploadContainer dragOver" : "uploadContainer"}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
    >
      <img src="/icons/Upload.svg" alt="uploadIcon" />
      <input
        data-testid="fileDropzone"
        type="file"
        name="file"
        hidden
        onChange={handleFileInputChange}
        accept=".csv,text/csv"
        ref={fileInput}
      />
      <div className="uploadTextPrimary">
        <Trans i18nKey={"select_single_csv"} />
      </div>
      <div className="uploadTextSecondary">
        <Trans i18nKey={"or_drag_drop_here"} />
      </div>
    </div>
  );
};

export default UploadCSV;
